import { useApiMutation } from "hooks/useApi/useApiHooks";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { socket } from "socket";
import {
  changeManager,
  finishedOrder,
  setIsFree,
  setSocketConnect,
  startOrder,
} from "store/reducers/OrderSlice";
import { useAppDispatch } from "store/storeHooks";
import { IOrder } from "types/common.types";

const useSocket = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dis = useAppDispatch();

  const { mutate: mutateStatus } = useApiMutation<{ isFree: boolean }>(
    "/employee/status",
    "post",
    {
      onSuccess() {},
    }
  );

  useEffect(() => {
    function onConnect() {
      console.log("Socket connected!");
      dis(setSocketConnect(true));
    }

    function onDisconnect() {
      console.log("Socket disconnected!");
      dis(setSocketConnect(false));
    }

    function onNewOrderEvent(order: IOrder) {
      console.log("New order: ", order);
      dis(
        changeManager({
          orderId: "",
          status: "initial",
          reason: "",
        })
      );
      dis(startOrder(order));
      navigate(`/order/order-person/${order?._id}`);
      if (order?._id) {
        setTimeout(() => {
          mutateStatus({ isFree: false });
          // socket.emit("change", {
          //   dispatcherId: _id,
          //   branchId: currentBranch._id,
          //   isFree: false,
          // });
        }, 1000);
      }
    }

    function onChangeEvent(change: { isFree: boolean }) {
      console.log("Change: ", change);
      dis(setIsFree(change?.isFree));
    }

    function onBotEvent(data: any) {
      console.log("bot: ", data);
      console.log("location?.pathname: ", location?.pathname);

      if (data?.isFree) {
        dis(finishedOrder());
        dis(
          changeManager({
            orderId: data?.orderId,
            status: "initial",
            reason: data?.reason,
          })
        );
        toast.success(`Buyurtma qabul qilindi!`);
        navigate("/order/table");
        // }
      } else {
        toast.error(`Menejer qabul qilmadi: ${data?.reason}`);
        dis(
          changeManager({
            orderId: data?.orderId,
            status: "error",
            reason: data?.reason,
          })
        );
      }
      // dis(changeManager(change?.isFree));
    }

    socket.connect();
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("newOrder", onNewOrderEvent);
    socket.on("change", onChangeEvent);
    socket.on("bot", onBotEvent);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("newOrder", onNewOrderEvent);
      socket.off("change", onChangeEvent);
      socket.off("bot", onBotEvent);
    };
  }, []);
  const handleChangeIsFree = (event: any) => {
    mutateStatus({
      // dispatcherId: _id,
      // branchId: currentBranch._id,
      isFree: event?.target?.checked,
    });
    if (!event?.target?.checked) {
      dis(finishedOrder());
    }
  };
  return handleChangeIsFree;
};

export default useSocket;
